module.exports = __webpack_public_path__ + "static/Kiki-11901e09109d3adc0cf176e4a7e9bb45.png";